import Link from "next/link";
import { Heading, Stack, Text } from "@chakra-ui/react";
import { HEADING_VARIANTS } from "@/theme/components/heading";
import {
  FOOTER_CONSTANTS,
  GENERAL_POLICIES_OPTION,
  DEDICATED_SERVERS_POLICY,
} from "../footer.constants";

const FooterGeneralPolicies = () => {
  return (
    <Stack spacing={6} color="white">
      <Heading variant={HEADING_VARIANTS.SUBTITLE2}>
        {FOOTER_CONSTANTS.GENERAL_POLICIES}
      </Heading>
      <Stack spacing={"0.6rem"}>
        {GENERAL_POLICIES_OPTION.map((service) => (
          <Link href={service.path} key={service.path}>
            <Text _hover={{ textDecor: "underline" }} lineHeight={1.3}>
              {service.name}
            </Text>
          </Link>
        ))}
      </Stack>
      <Heading variant={HEADING_VARIANTS.SUBTITLE2}>
        {FOOTER_CONSTANTS.DEDICATED_SERVERS_POLICY}
      </Heading>
      <Stack spacing={"0.6rem"}>
        {DEDICATED_SERVERS_POLICY.map((service) => (
          <Link href={service.path} key={service.path}>
            <Text _hover={{ textDecor: "underline" }} lineHeight={1.3}>
              {service.name}
            </Text>
          </Link>
        ))}
      </Stack>
    </Stack>
  );
};

export default FooterGeneralPolicies;
